import type { CSSProperties } from 'react';

import type { HistoryStepType } from './HistoryStep';
import { Communication, Development, Editor, General, Time, Users } from '../StrokeIcons';

type StepIconProps = {
  stepType: HistoryStepType;
  size?: number;
};

export function StepIcon({ stepType, size = 14 }: StepIconProps) {
  if (stepType === 'unknown') return null;
  const style = {
    '--icon-size': `${size}px`,
  } as CSSProperties;
  return (
    <div
      data-step-type={stepType}
      style={style}
      className="h-(--icon-size) min-h-(--icon-size) w-(--icon-size) min-w-(--icon-size) text-[hsl(227,27%,64%)] [&_svg]:h-full [&_svg]:w-full">
      {stepType === 'startedCadence' && <Development.GitBranch01 />}
      {stepType === 'error' && <Communication.AnnotationAlert />}
      {stepType === 'call' && <Communication.PhoneOutgoing01 />}
      {['document', 'visit'].includes(stepType) && <General.Eye />}
      {['message', 'connect', 'connectAccept'].includes(stepType) && <General.StepMessage />}
      {['mail', 'mailReplied'].includes(stepType) && <Communication.Mail02 />}
      {['inmail', 'declinedInmail'].includes(stepType) && <Communication.InMail04 />}
      {['comment', 'note'].includes(stepType) && <Editor.Pencil03 />}
      {stepType === 'reminder' && <Time.AlarmClock />}
      {stepType === 'stageChanged' && <Development.Dataflow03 />}
      {stepType === 'follow' && <General.Plus />}
      {stepType === 'owner' && <Users.User02 />}
      {stepType === 'postsLike' && <General.Heart />}
      {stepType === 'meetingBooked' && <Time.Calendar />}
      {stepType === 'contactUnavailable' && <General.XCircle />}
      {stepType === 'contactAvailable' && <General.CheckCircle />}
      {stepType === 'cadenceStateChanged' && <Development.GitBranch01 />}
    </div>
  );
}
